import { motion } from "motion/react";
import { Play } from "lucide-react";

export function LaunchHero() {
  return (
    <section className="relative pt-32 pb-20 bg-[#0B0E14] overflow-hidden">
      {/* Background */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[600px] bg-gradient-to-b from-[#00F5FF]/5 to-transparent pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center mb-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#FF4D00]/10 border border-[#FF4D00]/30 text-[#FF4D00] text-sm font-mono mb-6"
          >
            🚨 LANÇAMENTO OFICIAL
          </motion.div>
          
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight"
          >
            A Maneira Mais Rápida de <br />
            <span className="text-[#00F5FF]">Blindar Suas Campanhas</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-lg text-gray-400 max-w-2xl mx-auto"
          >
            Veja exatamente como o WPTT recuperou R$ 145.000 em vendas perdidas em apenas 30 dias com o novo sistema de Fingerprinting.
          </motion.p>
        </div>

        {/* Video Placeholder */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.3 }}
          className="relative max-w-5xl mx-auto aspect-video bg-[#000] rounded-2xl border border-[#00F5FF]/30 shadow-[0_0_100px_-20px_rgba(0,245,255,0.15)] overflow-hidden group"
        >
          {/* Fake Video UI */}
          <div className="absolute inset-0 flex items-center justify-center bg-[url('https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=2070&auto=format&fit=crop')] bg-cover bg-center">
             <div className="absolute inset-0 bg-black/60" />
             <div className="relative z-10 w-20 h-20 rounded-full bg-[#00F5FF]/20 backdrop-blur-sm border border-[#00F5FF] flex items-center justify-center group-hover:scale-110 transition-transform cursor-pointer">
               <Play className="w-8 h-8 text-white fill-white ml-1" />
             </div>
          </div>
          
          <div className="absolute bottom-0 left-0 right-0 h-1 bg-gray-800">
             <div className="h-full w-1/3 bg-[#00F5FF]" />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
